import { BaseHTMLAttributes, formatDate } from '@mi-front/core';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import React from 'react';

const DEFAULT_BG_COLOR = 'rgba(0,0,0,0.9)';

const StyledWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: 'sm' | 'md' }>(({ theme, size }) => ({
  display: 'block',
  color: theme.palette.common.white,
  borderRadius: '2px',
  fontSize: '0.75rem',
  lineHeight: '1rem',
  padding: '0.25rem 0.45rem',
  ...(size === 'sm' && {
    fontSize: '0.625rem',
    lineHeight: '0.75rem',
    padding: '0.25rem',
  }),
}));

const StyledStartEndWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  color: theme.palette.common.white,
  backgroundColor: '#92e1fe', // $color-AquaLight
  textAlign: 'center',
  height: '1.5rem',
  lineHeight: '1.5rem',
  fontSize: '0.75rem',
  borderRadius: '2px',
}));

const StyledIcon = styled('div')(({ theme }) => ({
  background: theme.palette.primary.main, // $color-Aqua
  padding: '0.25rem',
  '& path, & g': {
    fill: theme.palette.common.white,
  },
}));

const StyledStartIcon = styled(StyledIcon)({
  marginRight: '0.15rem',
  borderTopLeftRadius: '2px',
  borderBottomLeftRadius: '2px',
});

const StyledEndIcon = styled(StyledIcon)({
  marginLeft: '0.15rem',
  borderTopRightRadius: '2px',
  borderBottomRightRadius: '2px',
  marginRight: 0,
});

const StyledLabelText = styled('div')(({ theme }) => ({
  marginLeft: 'auto',
  width: '7rem',
  color: theme.palette.text.primary, // $color-Black
}));

interface Props extends BaseHTMLAttributes {
  readonly ts: number;
  readonly size?: 'sm' | 'md';
  readonly bgColor?: string;
  readonly children?: React.ReactNode;
  readonly tz?: string;
  readonly role?: string;
}

export function TimeLabel({ size, bgColor, ts, className, children, tz, style, ...rest }: Props) {
  return (
    <StyledWrapper
      size={size}
      style={{
        display: 'inline-block',
        background: bgColor || DEFAULT_BG_COLOR,
        ...style,
      }}
      className={classNames(className)}
      {...rest}
    >
      {children || formatDate(ts, 'HH:mm:ss', tz)}
    </StyledWrapper>
  );
}

// export function StartEndLabel({
//   startIcon,
//   endIcon,
//   children,
//   className,
//   ...rest
// }: {
//   startIcon?: React.ReactNode;
//   endIcon?: React.ReactNode;
//   children?: React.ReactNode;
//   className?: string;
// }) {
//   return (
//     <StyledStartEndWrapper className={classNames(className)} {...rest}>
//       {startIcon && <StyledStartIcon>{startIcon}</StyledStartIcon>}
//       <StyledLabelText>{children}</StyledLabelText>
//       {endIcon && <StyledEndIcon>{endIcon}</StyledEndIcon>}
//     </StyledStartEndWrapper>
//   );
// }
